import React from 'react'
import { Button, notification } from 'antd'
import { Route } from 'react-router-dom'

import { ItemList } from '~components'
import { getCurrentUser } from '~context'
import { PageLayout } from '~stories'

const NOTIFICATION_MESSAGES = {
  UNAUTHORIZED: 'You are not authorized to perform this action.'
}
const PAGE_TITLE = 'Structured Data'

const getDataFieldsNameWithLink = datafield => <a href={`structured-data/${datafield._id}/edit`}>{String(datafield?.title).toUpperCase()}</a>
const getDataFieldsNameWithStatus = datafield => <p>{String(datafield?.is_default)}</p>

const columnData = [
  {
    dataIndex: 'title',
    render: (text, dataField) => getDataFieldsNameWithLink(dataField),
    sorter: true,
    title: 'Title',
    width: '30%',
    sortDirections: ['descend', 'ascend', 'descend']
  },
  {
    dataIndex: 'type',
    title: 'Type',
    width: '40%'
  },
  {
    dataIndex: 'venue_id',
    title: 'Venue',
    width: '30%'
  },
  {
    dataIndex: 'updated_at',
    title: 'Last Updated',
    width: '30%'
  },
  {
    dataIndex: 'is_default',
    render: (text, dataField) => getDataFieldsNameWithStatus(dataField),
    title: 'Is Default',
    width: '30%'
  }
]

const addNewDataField = isContentEditor => {
  return (
    <Route render={({ history }) => (
      <Button
        key="1"
        onClick={() => {
          isContentEditor
            ? history.push('/structured-data/new')
            : notification.error({ message: NOTIFICATION_MESSAGES.UNAUTHORIZED })
        }}
        type="primary"
      >
        Add Structured Data
      </Button>
    )} />
  )
}

const DataFields = () => {
  const { userDetails: { isContentEditor } } = getCurrentUser()

  return (
    <PageLayout extra={[
      addNewDataField(isContentEditor)
    ]} title={PAGE_TITLE}>
      <div className="sponsors-layout-background">
        <ItemList columns={columnData} resource='dataFields' />
      </div>
    </PageLayout>
  )
}

export default DataFields
